<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">

    <div class="ps-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
                <li class="breadcrumb-item"><a href="javascript:;"><i class="bx bx-home-alt"></i></a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">ORDERS & POSITIONS</li>
            </ol>
        </nav>
    </div>
</div>
<!--end breadcrumb-->

<div class="card">
    <div class="card-body row">
        <div class="col-md-3">
            <select class="form-select" [(ngModel)]="filter_params.user_id" (change)="onUserChanged()" [ngModelOptions]="{standalone: true}">
                <option *ngFor="let u of users" [value]="u._id"> {{ u.full_name }}</option>
            </select>
        </div>
        <div class="col-md-3">
            <button type="button" class="btn btn-primary" (click)="loadOrderPositions()">Load</button>
        </div>
        <nav class="mt-3">
            <div class="nav nav-tabs" id="order-positions-nav-tab" role="tablist">
                <a class="nav-link active" id="nav-orders-tab" data-bs-toggle="tab" href="#nav-orders" role="tab" aria-controls="nav-orders" aria-selected="true" (click)="onTabSelected('orders')">Orders</a>
                <a class="nav-link" id="nav-positions-tab" data-bs-toggle="tab" href="#nav-positions" role="tab" aria-controls="nav-positions" aria-selected="false" (click)="onTabSelected('positions')">Positions</a>
            </div>
        </nav>
        <div class="tab-content" id="orderPositionsTabContent">
            <div class="tab-pane fade" [ngClass]="tabInfo.ordersCls" id="orders" role="tabpanel" aria-labelledby="orders-tab">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">Time</th>
                            <th scope="col">Symbol</th>
                            <th scope="col">Transaction</th>
                            <th scope="col">Product</th>
                            <th scope="col">Qty</th>
                            <th scope="col">Price/Trg Price</th>
                            <th scope="col">Avg Price</th>
                            <th scope="col">Status</th>
                            <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let order of orders">
                            <td scope="row">{{order.time}}</td>
                            <td scope="row">{{order.trading_symbol}}</td>
                            <td scope="row">{{order.transaction_type}}</td>
                            <td scope="row">{{order.qty_filled}}</td>
                            <td scope="row">{{order.product_type}}</td>
                            <td scope="row">{{order.price_trg_price}}</td>
                            <td scope="row">{{order.average_price}}</td>
                            <td scope="row">{{order.status}}</td>
                            <td scope="row">
                                <i class="bi bi-x-circle-fill text-danger" (click)="showCancelConfirmation('order', order)"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="orders.length == 0">{{ emsg }}</div>
            </div>
            <div class="tab-pane fade" id="positions" [ngClass]="tabInfo.positionsCls" role="tabpanel" aria-labelledby="positions-tab">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">Product</th>
                            <th scope="col">Symbol</th>
                            <th scope="col">Qty</th>
                            <th scope="col">Buy Price</th>
                            <th scope="col">Sell Price</th>
                            <th scope="col">PnL</th>
                            <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let position of positions">
                            <td scope="row">{{position.product_type}}</td>
                            <td scope="row">{{position.trading_symbol}}</td>
                            <td scope="row">{{position.qty}}</td>
                            <td scope="row">{{position.buy_avg_price}}</td>
                            <td scope="row">{{position.sell_avg_price}}</td>
                            <td scope="row">{{position.pnl}}</td>
                            <td scope="row">
                                <i *ngIf="position.show_close" class="bi bi-x-circle-fill text-danger" (click)="showCancelConfirmation('position', position)"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="positions.length == 0">{{ emsg }}</div>
            </div>
        </div>
    </div>
</div>


<div id="cancelOPConfirmationModal" class="modal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">ALERT</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeCancelConfirmation()"></button>
        </div>
        <div class="modal-body">
          <p>{{ cancelParams.msg }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary"  (click)="closeCancelConfirmation()">Close</button>
          <button type="button" class="btn btn-danger"  (click)="cancelOrderPosition(cancelParams)">Cancel</button>
        </div>
      </div>
    </div>
</div>
